export const watchlist: Record<string, string> = {
  // Page header
  'Tickers tracked:': 'Praćenih tikera:',
  'Add Ticker': 'Dodaj tiker',
  'Total Wins': 'Ukupno dobitaka',
  'Total Losses': 'Ukupno gubitaka',
  'Win Rate': 'Uspešnost',

  // Market filter (uppercase display values)
  'ALL': 'SVE',
  'FOREX': 'FOREX',
  'CRYPTO': 'KRIPTO',
  'STOCKS': 'AKCIJE',
  'INDICES': 'INDEKSI',
  'COMMODITIES': 'ROBA',

  // Add-ticker modal
  'Add to Watchlist': 'Dodaj na listu praćenja',
  'Ticker Symbol *': 'Simbol tikera *',
  'e.g. EURUSD, BTC, AAPL': 'npr. EURUSD, BTC, AAPL',
  'Market': 'Tržište',
  'Alert Price (optional)': 'Cena za alarm (opciono)',
  'Price level to watch': 'Nivo cene za praćenje',
  // 'Notes (optional)' already lives in channels.ts
  'Your analysis or reminders…': 'Tvoja analiza ili podsetnici…',
  'Adding…': 'Dodavanje…',
  'Failed to add ticker': 'Dodavanje tikera nije uspelo',
  'Network error. Please try again.': 'Greška na mreži. Pokušaj ponovo.',

  // Watchlist card
  'Copy to trade': 'Kopiraj u trejd',
  'Trade': 'Trejd',
  'Remove from watchlist': 'Ukloni sa liste praćenja',
  'No trade ideas posted yet': 'Još nema objavljenih trejd ideja',
  'WIN RATE': 'USPEŠNOST',
  'Alert at': 'Alarm na',

  // Errors + empty states
  'Failed to load watchlist': 'Učitavanje liste praćenja nije uspelo',
  'No tickers in this market': 'Nema tikera na ovom tržištu',
  'Your watchlist is empty': 'Tvoja lista praćenja je prazna',
  'Try a different market filter or add a new ticker.': 'Probaj drugi filter tržišta ili dodaj novi tiker.',
  'Start tracking tickers to monitor price levels, win/loss stats, and quickly copy trades.': 'Počni da pratiš tikere da bi nadgledao nivoe cena, statistiku dobitaka/gubitaka i brzo kopirao trejdove.',
  'Add Your First Ticker': 'Dodaj svoj prvi tiker',
  'Discover more trade ideas': 'Otkrij još trejd ideja',
};
